<script lang="ts">
  import type { LeaderboardRank } from '$lib/api/types';
  import { auth } from '$lib/stores/auth.svelte';
  import { scale } from 'svelte/transition';

  interface Props {
    firstPlace: LeaderboardRank;
    secondPlace?: LeaderboardRank | false;
    thirdPlace?: LeaderboardRank | false;
  }

  let { firstPlace, secondPlace, thirdPlace }: Props = $props();
</script>

{#snippet podiumItem(rank: LeaderboardRank)}
  {#if rank.studentId === auth.user!.userId}
    <div class="fw-bold">You!</div>
  {:else}
    <div>
      {rank.studentName}
    </div>
  {/if}
  <div class:fw-bold={rank.studentId === auth.user!.userId}>{rank.score} pt{rank.score === 1 ? '' : 's'}</div>
{/snippet}

<div class="podium-container">
  <div class="podium-img">
    <div class="pos-2" in:scale|global={{ delay: 200, start: 0.1, opacity: 0 }}>
      {#if secondPlace}
        {@render podiumItem(secondPlace)}
      {/if}
    </div>
    <div class="pos-1" in:scale|global={{ start: 0.1, opacity: 0 }}>
      {@render podiumItem(firstPlace)}
    </div>
    <div class="pos-3" in:scale|global={{ delay: 300, start: 0.1, opacity: 0 }}>
      {#if thirdPlace}
        {@render podiumItem(thirdPlace)}
      {/if}
    </div>
  </div>
  <!-- <img class="podium-img" src={podium} srcset="{podium2x} 2x, {podium} 1x" alt="podium" /> -->
</div>

<style>
  .podium-container {
    container-type: inline-size;
    container-name: podium-container;
  }

  @container podium-container (width > 0) {
    .podium-img {
      background-image: url($lib/assets/img/podium.webp);
      background-image: -webkit-image-set(url($lib/assets/img/podium.webp) 1x, url($lib/assets/img/podium_2x.webp) 2x);
      background-image: image-set(url($lib/assets/img/podium.webp) 1x, url($lib/assets/img/podium_2x.webp) 2x);
      background-position: bottom;
      background-repeat: no-repeat;
      background-size: 100%;
      width: 100%;

      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      gap: 2cqi;
      /*padding: 0 4cqi calc(37.5cqi - 30px);*/
      padding: 0 4cqi calc(29.5cqi - 2px); /* fine-tuned values to maintain perfect positioning as screen scales up */
    }
  }

  .podium-img > div {
    text-align: center;
    font-weight: normal;
    font-size: min(18px, calc(10px + 1.6cqi));
    white-space: nowrap;
    overflow: clip; /* helps the text-overflow: ellipsis in the child elements */
  }

  .podium-img > div > div {
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .pos-2,
  .pos-3 {
    min-height: calc(2lh + 7.5cqi - 3px); /* same height even if there is nothing in these divs */
    padding-top: calc(7.5cqi - 3px);
    /*padding-top: clamp(1rem, calc(125cqi - 500px), 2rem);*/
  }
</style>
